import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bzs8cq537a: FaireBrandEntity = {
  token: "b_bzs8cq537a",
  type: "brand",
  name: "Side By Side Chai",
  avatarUrl:
    "https://cdn.faire.com/fastly/6900e47a1e0e8a01b3230999f857084e9c4e9253205c8beb8ee4b9afb5fa7e62.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f92d69c89d1f6dbd78154dffaa629a5de1b38d3a5f7ab782b3fa1f256697ed1d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6900e47a1e0e8a01b3230999f857084e9c4e9253205c8beb8ee4b9afb5fa7e62.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f92d69c89d1f6dbd78154dffaa629a5de1b38d3a5f7ab782b3fa1f256697ed1d.jpeg",
  location: "Nashville, TN, USA",
  minimumOrderDollars: 40,
  rating: 5,
  reviewCount: 13,
  isInsider: true,
  description:
    "Our chai tea latte mix is created in and distributed from Nashville TN.  With the non-coffee drinker in mind who wants to have a beverage they're proud to rep. \n\nThere's no better way to connect with people than over a cup of coffee or tea and same goes for life; there's no better way to live life with the people around us than SIDE BY SIDE.\n\nSide by Side Chai tea latte mix is perfect to enjoy in the comfort of your own home.  Simply mix with your favorite milk or hot water.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:42.147Z",
    importedBy: "entity-db-cli",
  },
};
